// PWERM (Probability-Weighted Expected Return Method) — PSD §6.1 (F6.1). Engine layer.
import { fullyDilutedShares } from './fullyDiluted';
import { DLOM_CLAMP_MAX } from './constants';
/**
 * Probability-weighted scenario valuation. Each outcome is weighted by its probability.
 * Common value is allocated pro-rata across outcomes, DLOM applied via weighted time horizon.
 */
export function runPwerm(outcomes, capTable, _A, dlomPct) {
    if (outcomes.length === 0) {
        throw new Error('PWERM requires at least one outcome.');
    }
    const totalProb = outcomes.reduce((s, o) => s + o.probability, 0);
    if (totalProb <= 0) {
        throw new Error('PWERM probabilities must sum > 0.');
    }
    // Weighted equity value
    const weightedV = outcomes.reduce((s, o) => s + (o.probability / totalProb) * o.equityValue, 0);
    const fd = Math.max(1, fullyDilutedShares(capTable));
    const commonValuePre = weightedV;
    const dlom = Math.min(DLOM_CLAMP_MAX, Math.max(0, dlomPct));
    const commonValuePost = commonValuePre * (1 - dlom);
    const fmv = commonValuePost / fd;
    const headline = {
        totalEquityValue: weightedV,
        commonValuePreDlom: commonValuePre,
        commonValuePostDlom: commonValuePost,
        fullyDilutedShares: fd,
        commonFmvPerShare: fmv,
        recommendedStrikePrice: Math.ceil(fmv * 100) / 100,
        safeHarborWindowDays: 365,
        preferredPricePerShare: null,
        commonToPreferredDiscount: null,
        perShareByClass: [],
    };
    return { weightedEquityValue: weightedV, outcomes, allocation: [], headline };
}
// expose weighted time horizon for DLOM computation in caller
export function weightedTimeHorizon(outcomes) {
    const total = outcomes.reduce((s, o) => s + o.probability, 0);
    return total > 0 ? outcomes.reduce((s, o) => s + (o.probability / total) * o.timeToLiquidity, 0) : 0;
}
//# sourceMappingURL=pwerm.js.map